import { useTranslation } from "react-i18next";

const partners = [
  { name: "TechCabal", categoryKey: "apropos.partners.media", icon: "ri-newspaper-line", color: "text-orange-500", bg: "bg-orange-50" },
  { name: "Jeune Afrique", categoryKey: "apropos.partners.media", icon: "ri-global-line", color: "text-green-600", bg: "bg-green-50" },
  { name: "Forbes Africa", categoryKey: "apropos.partners.media", icon: "ri-bar-chart-line", color: "text-yellow-600", bg: "bg-yellow-50" },
  { name: "Partech Africa", categoryKey: "apropos.partners.investment", icon: "ri-funds-line", color: "text-purple-500", bg: "bg-purple-50" },
  { name: "Afrilabs", categoryKey: "apropos.partners.network", icon: "ri-group-line", color: "text-teal-600", bg: "bg-teal-50" },
  { name: "African Business", categoryKey: "apropos.partners.media", icon: "ri-briefcase-line", color: "text-rose-500", bg: "bg-rose-50" },
];

const timelineEn = [
  { year: "2023", event: "Creation of Wazi Stories Africa in Abidjan", icon: "ri-flag-line" },
  { year: "2024", event: "Platform launch with the first 50 stories", icon: "ri-rocket-line" },
  { year: "2024", event: "Reached 10,000 monthly readers in 3 months", icon: "ri-user-line" },
  { year: "2025", event: "Partnerships with TechCabal, Forbes Africa and Jeune Afrique", icon: "ri-links-line" },
  { year: "2025", event: "Launch of the African Diaspora section", icon: "ri-earth-line" },
  { year: "2026", event: "120,000 monthly readers, 54 countries covered", icon: "ri-trophy-line" },
];

const timelineFr = [
  { year: "2023", event: "Création de Wazi Stories Afrique à Abidjan", icon: "ri-flag-line" },
  { year: "2024", event: "Lancement de la plateforme avec 50 premières histoires", icon: "ri-rocket-line" },
  { year: "2024", event: "Passage à 10 000 lecteurs mensuels en 3 mois", icon: "ri-user-line" },
  { year: "2025", event: "Partenariats avec TechCabal, Forbes Africa et Jeune Afrique", icon: "ri-links-line" },
  { year: "2025", event: "Lancement de la section Diaspora Africaine", icon: "ri-earth-line" },
  { year: "2026", event: "120 000 lecteurs mensuels, 54 pays couverts", icon: "ri-trophy-line" },
];

export default function PartnersSection() {
  const { t, i18n } = useTranslation();
  const timeline = i18n.language === "en" ? timelineEn : timelineFr;

  return (
    <>
      {/* Timeline */}
      <section className="py-12 md:py-20 bg-white">
        <div className="max-w-[1400px] mx-auto px-4 md:px-8">
          <div className="text-center mb-8 md:mb-12">
            <div className="w-10 h-1 rounded-full bg-orange-500 mx-auto mb-3"></div>
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 font-serif">{t("apropos.timeline.title")}</h2>
            <p className="text-gray-500 mt-2">{t("apropos.timeline.subtitle")}</p>
          </div>

          <div className="relative max-w-3xl mx-auto">
            <div className="absolute left-5 md:left-1/2 top-0 bottom-0 w-px bg-orange-100 md:-translate-x-1/2"></div>

            <div className="space-y-6 md:space-y-8">
              {timeline.map((item, i) => (
                <div
                  key={i}
                  className={`relative flex items-start gap-4 md:gap-6 ${i % 2 === 0 ? "md:flex-row" : "md:flex-row-reverse"}`}
                >
                  <div className="absolute left-5 md:left-1/2 md:-translate-x-1/2 w-3 h-3 md:w-4 md:h-4 rounded-full bg-orange-500 border-4 border-orange-100 z-10 mt-1.5"></div>

                  <div className={`ml-12 md:ml-0 md:w-[calc(50%-2rem)] ${i % 2 === 0 ? "md:pr-8 md:text-right" : "md:pl-8"}`}>
                    <div className="bg-[#fdf8f3] rounded-2xl p-4 md:p-5 border border-orange-100 inline-block w-full">
                      <div className="flex items-center gap-2 mb-2 flex-wrap">
                        <span className="bg-orange-500 text-white text-xs font-bold px-3 py-1 rounded-full">{item.year}</span>
                        <div className="w-5 h-5 md:w-6 md:h-6 flex items-center justify-center">
                          <i className={`${item.icon} text-orange-400 text-sm md:text-base`}></i>
                        </div>
                      </div>
                      <p className="text-gray-700 text-sm font-medium leading-relaxed">{item.event}</p>
                    </div>
                  </div>

                  <div className="hidden md:block md:w-[calc(50%-2rem)]"></div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Partners */}
      <section className="py-10 md:py-16 bg-[#fdf8f3]">
        <div className="max-w-[1400px] mx-auto px-4 md:px-8">
          <div className="text-center mb-8 md:mb-10">
            <div className="w-10 h-1 rounded-full bg-orange-500 mx-auto mb-3"></div>
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 font-serif">{t("apropos.partners.title")}</h2>
            <p className="text-gray-500 mt-2">{t("apropos.partners.subtitle")}</p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-5">
            {partners.map((p) => (
              <div
                key={p.name}
                className="bg-white rounded-2xl p-4 md:p-6 text-center border border-gray-100 hover:-translate-y-1 transition-transform duration-300 group"
              >
                <div className={`w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-xl mx-auto mb-2 md:mb-3 ${p.bg} group-hover:scale-110 transition-transform`}>
                  <i className={`${p.icon} text-xl md:text-2xl ${p.color}`}></i>
                </div>
                <div className="font-bold text-gray-900 text-xs md:text-sm mb-1">{p.name}</div>
                <div className="text-xs text-gray-400 hidden sm:block">{t(p.categoryKey)}</div>
              </div>
            ))}
          </div>

          <div className="mt-6 md:mt-8 text-center">
            <p className="text-gray-500 text-sm mb-3 md:mb-4">{t("apropos.partners.cta.text")}</p>
            <a
              href="mailto:partenariats@wazistories.africa"
              className="inline-flex items-center gap-2 border border-orange-500 text-orange-500 hover:bg-orange-500 hover:text-white font-semibold px-5 md:px-6 py-2.5 md:py-3 rounded-full transition-colors cursor-pointer whitespace-nowrap text-sm"
            >
              <i className="ri-links-line"></i>
              {t("apropos.partners.cta.btn")}
            </a>
          </div>
        </div>
      </section>
    </>
  );
}
